/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { object, string } from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Divider } from '@material-ui/core';
import AddMailingAddressForm from './AddMailingAddressForm';

const AddMailingAddress = ({ classes, parentComponent }) => {
    const methods = useFormContext();

    return (
        <div className={classes.addMailingAddress}>
            <div className="headerContainer">
                <h3>Address</h3>
            </div>
            <Divider className={classes.dividerStyle} />
            <div className="addMailingFormContainer">
                <AddMailingAddressForm methods={methods} classes={classes} />
                <hr style={{ marginTop: parentComponent === 'DesktopAddNewRecipient' ? '24px' : '20px' }} className={classes.dottedDivider} />
            </div>
        </div>
    );
};

AddMailingAddress.propTypes = {
    classes: object.isRequired,
    parentComponent: string.isRequired,
};

export default AddMailingAddress;
